export default "__VITE_ASSET__1yonLwuu__"